import Vue from 'vue'
import Router from 'vue-router'

const index = r => require.ensure([], () => r(require('@/components/index')), 'chunkname1');

Vue.use(Router)

export default new Router({
  routes: [
    { path: '/', name: 'Index', component:  index },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js